function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { perfectCard, deleteCard, formalCard, quitCard, importCardApi, getTemp, getInterview } from '@/api/enterprise';
import file from '@/utils/file';
import Vue from 'vue';
Vue.use(file);
export default {
  props: {
    componentName: {
      type: String,
      default: 'notNewEmployees'
    }
  },
  data: function data() {
    return {
      // 组件名称 -> 对应 Vue - component :is 属性 动态组件
      // componentName: 'notNewEmployees',
      selectAll: false,
      isLoading: false,
      linkShow: false,
      distinguish: 2,
      columnNumber: 4,
      formDataInit: {
        name: '',
        quit_time: '',
        info: '',
        mark: '',
        user_id: ''
      },
      formConfig: [{
        type: 'input',
        label: '人员姓名：',
        placeholder: '人员姓名',
        key: 'name',
        disabled: true
      }, {
        type: 'date',
        label: '离职时间：',
        placeholder: '选择时间',
        key: 'quit_time',
        format: 'yyyy-MM-dd'
      }, {
        type: 'input',
        label: '离职原因：',
        placeholder: '请输入离职原因',
        key: 'info'
      }, {
        type: 'textarea',
        label: '离职备注：',
        placeholder: '请输入备注',
        key: 'mark'
      }, {
        type: 'user_id',
        label: '交接人员：',
        placeholder: '请选择人员',
        only_one: true,
        key: 'user_id',
        tips: '提示：办理离职后，系统将自动停用离职人员的账号，离职人员所有待办事项转移交接人员处理。'
      }],
      copyName: '',
      url: '',
      tabtypes: 0,
      dataType: 0,
      joinType: '',
      linkTitle: '邀请个人完善档案信息',
      linkTable: '复制邀请链接，粘贴至微信/QQ等，快速邀请员工加入并完善个人档案！',
      linkContent: '提示：被邀请人员登录《陀螺匠·企业助手》，同意加入企业之后，填写「个人简历」之后会同步至员工档案中。',
      quit: {},
      userList: [],
      actionType: '',
      fromData: {
        width: '600px',
        title: '办理离职',
        btnText: '确定',
        labelWidth: '90px',
        type: ''
      },
      formRules: {
        quit_time: [{
          required: true,
          message: '请选择离职时间',
          trigger: 'blur'
        }],
        info: [{
          required: true,
          message: '请输入离职原因',
          trigger: 'blur'
        }],
        user_id: [{
          required: true,
          message: '请选择交接人员',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    setTabTypes: function setTabTypes() {
      var tab = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      localStorage.setItem('tabTypes', tab.toString());
      this.tabtypes = tab;
    },
    // 删除: 单个
    onDelete: function onDelete(data) {
      var _this = this;
      this.$modalSure(this.$t('business.message10')).then(function () {
        deleteCard(data.id).then(function (res) {
          _this.$refs.dynamic.getList();
        });
      });
    },
    // 刷新档案列表数据
    getList: function getList() {
      this.$refs.dynamic.getList(1);
    },
    // 点击转正
    onWorker: function onWorker(data) {
      var _this2 = this;
      this.$modalForm(formalCard(data.id)).then(function (_ref) {
        var message = _ref.message;
        _this2.getList();
      });
    },
    // 打开离职
    onQuit: function onQuit(data) {
      this.$refs.oaDialog.openBox();
      this.formDataInit.name = data.name;
      this.formDataInit.id = data.id;
    },
    submit: function submit(data) {
      var _this3 = this;
      data.user_id = data.user_id[0];
      quitCard(data.id, data).then(function (res) {
        _this3.$refs.oaDialog.handleClose();
        _this3.$refs.dynamic.getList();
      }).catch(function (err) {
        _this3.isLoading = false;
      });
    },
    // 导出上传模板
    exportTemplate: function exportTemplate() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getTemp();
            case 2:
              result = _context.sent;
              _this4.fileLinkDownLoad(result.data.url, '员工档案导入模板.xlsx');
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 选择交接人员关闭
    departmentClose: function departmentClose() {
      this.openStatus = false;
    },
    // 选择成员完成回调
    changeMastart: function changeMastart(data) {
      this.userList = data;
    },
    // 导入
    importExcelData: function importExcelData(data) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res, newData, i, _data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              res = [];
              newData = data;
              if (!(newData.length <= 0)) {
                _context2.next = 6;
                break;
              }
              _this5.$message.error('批量导出内容为空');
              _context2.next = 25;
              break;
            case 6:
              i = 0;
            case 7:
              if (!(i <= newData.length - 1)) {
                _context2.next = 20;
                break;
              }
              if (!(newData[i][0] === '')) {
                _context2.next = 12;
                break;
              }
              return _context2.abrupt("continue", 17);
            case 12:
              if (newData[i][5] == '正式') {
                newData[i][5] = 1;
              } else if (newData[i][5] == '试用') {
                newData[i][5] = 2;
              } else if (newData[i][5] == '实习') {
                newData[i][5] = 3;
              } else if (newData[i][5] == '离职') {
                newData[i][5] = 4;
              }
              if (newData[i][4] == '兼职') {
                newData[i][4] = 1;
              } else if (newData[i][4] == '全职') {
                newData[i][4] = 0;
              } else if (newData[i][4] == '实习') {
                newData[i][4] = 2;
              } else if (newData[i][4] == '劳务派遣') {
                newData[i][4] = 3;
              } else if (newData[i][4] == '退休返聘') {
                newData[i][4] = 4;
              } else if (newData[i][4] == '劳务外包') {
                newData[i][4] = 5;
              } else if (newData[i][4] == '其他') {
                newData[i][4] = 6;
              } else {
                newData[i][4] = 0;
              }
              if (newData[i][1] == '男') {
                newData[i][1] = 1;
              } else if (newData[i][1] == '女') {
                newData[i][1] = 2;
              } else {
                newData[i][1] = 0;
              }
              if (newData[i][2] == '研究生') {
                newData[i][2] = 6;
              } else if (newData[i][2] == '本科') {
                newData[i][2] = 5;
              } else if (newData[i][2] == '专科') {
                newData[i][2] = 4;
              } else if (newData[i][2] == '高中及以下') {
                newData[i][2] = 2;
              }
              res.push({
                name: newData[i][0],
                sex: newData[i][1],
                education: newData[i][2],
                phone: newData[i][3],
                is_part: newData[i][4],
                type: newData[i][5],
                position: '',
                frames: '',
                card_id: newData[i][6]
              });
            case 17:
              i++;
              _context2.next = 7;
              break;
            case 20:
              _data = {
                type: _this5.tabtypes,
                data: res
              };
              _context2.next = 23;
              return importCardApi(_data);
            case 23:
              _context2.next = 25;
              return _this5.$refs.dynamic.getList();
            case 25:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 打开邀请链接弹窗
    invitationFn: function invitationFn(data, type) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var dataId, result, _result, id;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this6.joinType = type;
              if (data !== 1) {
                _this6.copyName = data.name;
                dataId = data.id;
              } else {
                _this6.dataType = data;
                dataId = 0;
              }
              if (!(_this6.tabtypes == 0)) {
                _context3.next = 10;
                break;
              }
              _context3.next = 5;
              return getInterview();
            case 5:
              result = _context3.sent;
              _this6.linkShow = true;
              _this6.url = result.data.url.url;
              _context3.next = 14;
              break;
            case 10:
              _context3.next = 12;
              return perfectCard(dataId);
            case 12:
              _result = _context3.sent;
              if (_result.data.url.url == '') {} else {
                _this6.linkShow = true;
                _this6.url = _result.data.url.url;
              }
            case 14:
              if (_this6.tabtypes === 0) {
                _this6.linkTitle = '邀请填写求职登记表';
                _this6.linkTable = '复制邀请链接，粘贴至微信/QQ等，快速邀请求职者填写求职登记表！';
                _this6.linkContent = '被邀请人员点击邀请链接，通过手机号码登录《陀螺匠·企业助手》，填写个人求职信息之后会同步至员工档案-未入职人员数据中。';
              } else if (_this6.tabtypes === 1 && data === 1) {
                _this6.linkTitle = '邀请个人完善档案信息';
                _this6.linkTable = '复制邀请链接，粘贴至微信/QQ等，快速邀请员工加入并完善个人档案！';
                _this6.linkContent = '被邀请人员登录《陀螺匠·企业助手》，同意加入企业之后，填写「个人简历」之后会同步至员工档案中。';
              }
              id = 0;
              if (data !== 1) {
                id = data.id;
                _this6.linkTitle = '邀请成员';
                _this6.linkTable = '复制邀请链接，粘贴至微信/QQ等，快速邀请成员加入！';
                if (type == 'invite') {
                  _this6.linkContent = '被邀请员工点击邀请链接，通过手机号码登录陀螺匠办公系统，同意后直接加入组织架构。';
                } else {
                  _this6.linkContent = '被邀请员工点击邀请链接，通过手机号码登录陀螺匠办公系统，填写「个人简历」之后会同步至员工档案中。';
                }
              } else {
                id = 0;
              }
            case 17:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 复制邀请链接
    copy: function copy() {
      var oInput = document.createElement('input');
      var name = JSON.parse(localStorage.getItem('enterprise'));
      var value = '';
      if (this.tabtypes == 0) {
        value = '【' + name.enterprise_name + '】邀请您填写求职登记表' + ',' + '请您点击链接使用手机号验证登录' + this.url + ' 感谢您的配合，我们期待您的加入！';
      } else if (this.tabtypes === 1 && this.dataType === 1) {
        var realName = JSON.parse(localStorage.getItem('userInfo'));
        value = '【' + realName.real_name + '】邀请您加入' + '【' + name.enterprise_name + '】' + '自动化办公系统，请您点击链接使用手机号验证码登录，同意加入企业并完善个人档案' + this.url + ' 感谢您的配合，谢谢！';
      } else if (this.tabtypes === 1 && this.joinType === 'invite') {
        value = '【' + this.copyName + '】邀请您加入' + '【' + name.enterprise_name + '】' + '自动化办公系统，请您点击链接使用手机号验证码登录，同意加入企业并完善个人档案' + this.url + ' 感谢您的配合，谢谢！';
      } else if (this.tabtypes === 1 && this.dataType !== 1) {
        value = '亲爱的【' + this.copyName + '】请您完善员工档案信息' + ',' + '请点击链接使用手机号验证登录' + this.url + ' 在「个人简历」中完善信息之后，发送给【' + name.enterprise_name + '】';
      }
      oInput.value = value;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand('Copy');
      oInput.style.display = 'none';
      document.body.removeChild(oInput);
      this.$message.success('复制成功');
      this.handleClose();
    },
    // 关闭邀请链接弹窗
    handleClose: function handleClose() {
      this.linkShow = false;
    },
    openDrawer: function openDrawer(componentName, type, data, text) {
      switch (componentName) {
        // 人员详情
        case 'addDrawerIsShow':
          {
            if (type === 'edit') {
              this.$refs.userDetails.id = data.id;
              this.actionType = text;
            }
            this.$refs.userDetails.init({
              componentName: componentName,
              type: type
            });
            break;
          }
      }
    }
  },
  components: {
    Table: function Table() {
      return import('./components/table.vue');
    },
    // 在职员工
    jobEmployees: function jobEmployees() {
      return import('./components/index/employees.vue');
    },
    // 未入职员工
    notNewEmployees: function notNewEmployees() {
      return import('./components/index/notEmployees.vue');
    },
    // 离职员工
    resignedEmployee: function resignedEmployee() {
      return import('./components/index/quitEmployees.vue');
    },
    // 档案信息弹窗
    UserDetails: function UserDetails() {
      return import('./components/userDetails.vue');
    },
    oaDialog: function oaDialog() {
      return import('@/components/form-common/dialog-form');
    },
    // 导入
    importExcel: function importExcel() {
      return import('@/components/common/importExcel');
    }
  }
};